import { makeRequest } from "../helpers/makeRequest";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { alertSelectListUrl } from "../helpers/apiUrls";
import { prepareUrlWithQueryParams } from "../helpers/methods";

export default function useAlertService() {
  const axiosPrivate = useAxiosPrivate();

  const getAlertSelectList = (searchParams) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(alertSelectListUrl, searchParams)
    );
  };

  return {
    getAlertSelectList,
  };
}
